<template>
  <div v-if="bookRender" class="c-bottom-bar__pages-limit is-centered">
    <span class="is-centered">
      <input
        v-if="isTwoPageLayout"
        type="text"
        :value="
          bookDirection
            ? bookRender.secondPageNumber + '/' + bookRender.currentPageNumber
            : bookRender.currentPageNumber + '/' + bookRender.secondPageNumber
        "
        @change="onChange"
        @click="onSelect"
      />
      <input
        v-else
        type="number"
        :value="bookRender.currentPageNumber"
        @keyup.enter="onChange"
        @click="onSelect"
      />
      <strong>{{
        $t('PAGES_OUT_OF_TOTAL', { 0: bookRender.getTotalPages() })
      }}</strong>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    isTwoPageLayout: Boolean,
    bookRender: Object,
    bookDirection: Boolean,
  },

  methods: {
    onChange(ev) {
      this.$emit('change-pages-limit', ev)
    },

    onSelect(ev) {
      this.$emit('select-pages-limit', ev)
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-bottom-bar__pages-limit {
  width: 135px;
  height: 32px;
  float: left;
  padding: 3px 0;
  font-size: 14px;

  .c-book__pages-limit-wrapper & {
    display: inline-block;
    float: none;
  }

  strong {
    color: $blue;
  }

  input {
    margin: 0 8px 0 0;
    padding: 0;
    text-align: center;
    width: 5em;
    border: 2px solid $blue;
    line-height: 22px;
    color: $blue;

    @include a11yOutline();
  }

  input[type='number'] {
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  }
}
</style>
